import { NumberFormatValues, NumericFormat, OnValueChange } from "react-number-format";
import cx from "classnames";
import { ChevronDownIcon } from "../icons";
import { useNumberFormat } from "../../utils";

export function Input( props: {
	id: string,
	className?: string,
	label?: string,
	defaultValue?: string,
	maxlength?: number,
	register: { [ key: string ]: any; },
	numberFormat?: boolean | 'int' | 'decimal',
	onValueChange?: ( value?: NumberFormatValues ) => void
} ) {
	const format = useNumberFormat();

	if ( props.numberFormat && props.numberFormat == 'int' ) {
		format.decimalScale = 0;
	}

	if ( props.numberFormat && props.maxlength ) {
		if ( props.maxlength <= 4 ) {
			format.thousandSeparator = '';
		}
	}

	return (
		<div className={ cx( 'relative w-full', props.className ) }>
			{ props.numberFormat
				?
					<NumericFormat
						{ ...props.register }
						onValueChange={ props.onValueChange }
						defaultValue={ props.defaultValue }
						type='text'
						name={ props.id }
						id={ props.id }
						{ ...format }
						className={ cx( Input.css(), 'px-2.5 pb-2.5 pt-4 peer' ) } placeholder=" "
					/>
				:
					<input
						{ ...props.register }
						defaultValue={ props.defaultValue }
						type="text"
						name={ props.id }
						id={ props.id }
						className={ cx( Input.css(), 'px-2.5 pb-2.5 pt-4 peer' ) } placeholder=" "
					/>
			}

			<label
				htmlFor={ props.id }
				className="cursor-text absolute text-sm text-ui-700 duration-200 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4"
			>{ props.label }</label>
		</div>
	);
}

Input.css = function () {
	return "block rounded-md w-full text-ui-700 border border-ui-300 appearance-none bg-none focus:outline-none focus:ring-1 focus:ring-ui-primary focus:border-ui-primary";
}

export function Select( props: {
	id: string,
	name: string,
	className?: string,
	label?: string,
	defaultValue?: string,
	maxlength?: number,
	register: { [ key: string ]: any; },
} ) {

	return (
		<div className={ cx( 'relative w-full', props.className ) }>
			<select
					{ ...props.register }
					defaultValue={ props.defaultValue }
					name={ props.name ? props.name : props.id }
					id={ props.id }
					className={ cx( Input.css(), 'px-2.5 pr-6 pb-2.5 pt-4 peer' ) }
			>
				{ props.children }
			</select>

			<label
				htmlFor={ props.id }
				className="cursor-text absolute text-sm text-ui-700 duration-200 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4"
			>{ props.label }</label>

			<div className="absolute inset-y-0 flex items-center px-2 pointer-events-none right-2 text-primary-700">
				<ChevronDownIcon />
			</div>
		</div>
	);
}

export function Radio( props: {
	id: string,
	label?: string,
	defaultValue?: string,
	register: { [ key: string ]: any; }
} ) {
	const input = <input
		type="radio"
		className={ cx(
			"w-5 h-5 border-ui-300 text-ui-700 appearance-none cursor-pointer",
			"focus:outline-none focus:ring-0 focus:ring-offset-0",
			"focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-ui-primary",
			"hover:border hover:border-ui-primary"
		) }
		id={ props.id }
		{ ...props.register }
		defaultValue={ props.defaultValue }
	/>;

	// whitespace-nowrap manuell einfügen! über className
	if ( props.label ) {
		return (
			<div className="flex items-center">
				{ input }
				<label htmlFor={ `${ props.id }` } className={ 'ml-3 cursor-pointer' }>
					{ props.label }
				</label>
			</div>
		)
	} else {
		return (
			input
		)
	}
}


export function Checkbox( props: {
	id: string,
	label?: string,
	value?: string,
	register: { [ key: string ]: any; }
} ) {
	const input = <input
		type="checkbox"
		id={ props.id }
		className={ cx(
			"w-5 h-5 border-ui-300 rounded text-ui-700 appearance-none cursor-pointer",
			"focus:outline-none focus:ring-0 focus:ring-offset-0",
			"focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-ui-primary",
			"hover:border hover:border-ui-primary"
		) }
		{ ...props.register }
		value={ props.value }
	/>;

	if ( props.label ) {
		return (
			<div className="flex items-center">
				{ input }
				<label htmlFor={ `${ props.id }` } className="ml-3 cursor-pointer whitespace-nowrap">
					{ props.label }
				</label>
			</div>
		)
	} else {
		return (
			input
		)
	}
}
